import React from 'react';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import Map from '../components/Map';

const Contact = () => {
  return (
    <>
      {/* Contact Information Section */}
      <div className="py-16 bg-gray-900 text-white">
        <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Phone */}
          <div className="text-center">
            <FaPhoneAlt size={40} className="text-red-700 mx-auto mb-4" />
            <h3 className="text-xl font-semibold">Phone</h3>
            <p className="text-gray-400 mt-2">
              Experience the authentic flavors of Asia at our restaurant.
            </p>
            <p className="text-gray-100 font-medium mt-2">+358 417406648</p>
          </div>
          {/* Email */}
          <div className="text-center">
            <FaEnvelope size={40} className="text-red-700 mx-auto mb-4" />
            <h3 className="text-xl font-semibold">Email</h3>
            <p className="text-gray-400 mt-2">
              Contact us for reservations or any inquiries.
            </p>
            <p className="text-gray-100 font-medium mt-2">everestmomocafe@gmail.com</p>
          </div>
          {/* Location */}
          <div className="text-center">
            <FaMapMarkerAlt size={40} className="text-red-700 mx-auto mb-4" />
            <h3 className="text-xl font-semibold">Location</h3>
            <p className="text-gray-400 mt-2">
              Join us for a delightful dining experience.
            </p>
            <p className="text-gray-100 font-medium mt-2">
              Eerikinkatu 29, 20100 Turku, Finland
            </p>
          </div>
        </div>
      </div>

      {/* Map Section */}
      <div className="bg-gray-100 py-16">
        <div className="container mx-auto">
          <h2 className="text-3xl font-bold text-center mb-8">Our Location</h2>
          <div className="border rounded-lg overflow-hidden shadow-lg">
            <Map />
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
